var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.5,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#EEEFF1",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 30C24.1716 30 23.5 30.6716 23.5 31.5C23.5 32.3284 24.1716 33 25 33C25.8284 33 26.5 32.3284 26.5 31.5C26.5 30.6716 25.8284 30 25 30Z",
    fill: "#556370"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 24C24.1716 24 23.5 24.6716 23.5 25.5C23.5 26.3284 24.1716 27 25 27C25.8284 27 26.5 26.3284 26.5 25.5C26.5 24.6716 25.8284 24 25 24Z",
    fill: "#556370"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 18C24.1716 18 23.5 18.6716 23.5 19.5C23.5 20.3284 24.1716 21 25 21C25.8284 21 26.5 20.3284 26.5 19.5C26.5 18.6716 25.8284 18 25 18Z",
    fill: "#556370"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.e2fe46e2f3fcf32141bb6d7ac3387e98.svg";
export { ForwardRef as ReactComponent };